import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { clearAllGetCache } from '../services/api';

const AUTH_STORAGE_KEY = 'chse_logged_in';
const AUTH_TOKEN_KEY = 'chse_auth_token';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authPopupOpen, setAuthPopupOpen] = useState(false);

  const performLogout = useCallback(() => {
    setIsLoggedIn(false);
    setAuthPopupOpen(false);
    try {
      window.localStorage.removeItem(AUTH_STORAGE_KEY);
      window.localStorage.removeItem(AUTH_TOKEN_KEY);
      window.sessionStorage.removeItem('chse_otp_token');
      window.sessionStorage.removeItem('chse_otp_mobile');
    } catch {
      // ignore storage errors
    }
    clearAllGetCache();
  }, []);

  useEffect(() => {
    try {
      window.sessionStorage.removeItem('chse_auth_popup_dismissed');
    } catch {
      // ignore
    }
    try {
      const stored = window.localStorage.getItem(AUTH_STORAGE_KEY);
      const loggedIn = stored === 'true';
      setIsLoggedIn(loggedIn);
      setAuthPopupOpen(false);
    } catch {
      setIsLoggedIn(false);
      setAuthPopupOpen(false);
    }
  }, []);

  const value = useMemo(() => {
    return {
      isLoggedIn,
      authPopupOpen,
      openAuthPopup: () => {
        if (!isLoggedIn) setAuthPopupOpen(true);
      },
      closeAuthPopup: () => setAuthPopupOpen(false),
      login: (authToken) => {
        setIsLoggedIn(true);
        setAuthPopupOpen(false);
        try {
          window.localStorage.setItem(AUTH_STORAGE_KEY, 'true');
          if (authToken) window.localStorage.setItem(AUTH_TOKEN_KEY, authToken);
        } catch {
          // ignore storage errors
        }
      },
      logout: performLogout,
    };
  }, [authPopupOpen, isLoggedIn, performLogout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return ctx;
}

